/**
 * Script para o dropdown personalizado com reinicialização após AJAX
 */

// Função principal para inicializar o dropdown
function initializeCustomDropdown() {
    console.log('Inicializando dropdowns personalizados');

    // Selecionar TODOS os elementos dropdown (não apenas o primeiro)
    const customDropdowns = document.querySelectorAll('.custom-dropdown');
    const originalSelect = document.querySelector('#SortBy');

    // Verificar se os elementos existem
    if (!customDropdowns.length || !originalSelect) {
        console.log('Elementos não encontrados para o dropdown personalizado');
        return;
    }

    // Inicializar cada dropdown encontrado na página
    customDropdowns.forEach(function(customDropdown) {
        const customSelected = customDropdown.querySelector('.custom-dropdown__selected');
        const customOptionItems = customDropdown.querySelectorAll('.custom-dropdown__option');

        if (!customSelected) return;

        // Remover qualquer listener antigo (para evitar duplicação)
        if (customSelected._hasClickListener) {
            customSelected.removeEventListener('click', customSelected._clickHandler);
        }

        // Função para alternar o dropdown
        const toggleDropdown = function(e) {
            e.stopPropagation();
            customDropdown.classList.toggle('custom-dropdown--open');
        };

        // Armazenar referência ao handler
        customSelected._clickHandler = toggleDropdown;
        customSelected._hasClickListener = true;

        // Adicionar evento de clique
        customSelected.addEventListener('click', customSelected._clickHandler);

        // Adicionar eventos para cada opção
        customOptionItems.forEach(function(option) {
            // Remover qualquer listener antigo
            if (option._hasClickListener) {
                option.removeEventListener('click', option._clickHandler);
            }

            // Função para selecionar opção
            const optionClickHandler = function() {
                const value = this.dataset.value;

                // Atualizar dropdown personalizado visualmente
                if (customDropdown.querySelector('.custom-dropdown__selected-text')) {
                    customDropdown.querySelector('.custom-dropdown__selected-text').textContent = this.textContent.trim();
                }

                customOptionItems.forEach(function(opt) {
                    opt.classList.remove('custom-dropdown__option--selected');
                });

                this.classList.add('custom-dropdown__option--selected');
                customDropdown.classList.remove('custom-dropdown--open');

                // Atualizar o valor no select original
                if (originalSelect.value !== value) {
                    originalSelect.value = value;

                    // Acionar o AJAX usando o componente FacetFiltersForm
                    try {
                        const facetFiltersForm = document.querySelector('facet-filters-form');

                        if (facetFiltersForm) {
                            console.log('Acionando AJAX via FacetFiltersForm');

                            // Criar evento simulado
                            const simulatedEvent = {
                                preventDefault: function() {},
                                target: originalSelect,
                                srcElement: { className: '' }
                            };

                            // Chamar método de submissão
                            facetFiltersForm.onSubmitHandler(simulatedEvent);
                        } else {
                            // Fallback
                            console.log('FacetFiltersForm não encontrado, usando fallback');
                            const url = new URL(window.location.href);
                            url.searchParams.set('sort_by', value);
                            window.location.href = url.toString();
                        }
                    } catch (error) {
                        console.error('Erro ao acionar AJAX:', error);
                        const url = new URL(window.location.href);
                        url.searchParams.set('sort_by', value);
                        window.location.href = url.toString();
                    }
                }
            };

            // Armazenar referência ao handler
            option._clickHandler = optionClickHandler;
            option._hasClickListener = true;

            // Adicionar evento
            option.addEventListener('click', option._clickHandler);
        });
    });

    // Fechar todos os dropdowns ao clicar fora
    const outsideClickHandler = function(e) {
        customDropdowns.forEach(function(dropdown) {
            if (dropdown && !dropdown.contains(e.target)) {
                dropdown.classList.remove('custom-dropdown--open');
            }
        });
    };

    // Remover handler antigo e adicionar o novo
    document.removeEventListener('click', window._outsideClickHandler);
    document.addEventListener('click', outsideClickHandler);
    window._outsideClickHandler = outsideClickHandler;

    console.log('Dropdowns personalizados inicializados com sucesso');
}

// Inicializar quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', function() {
    initializeCustomDropdown();

    // Observar mudanças no DOM para reinicializar após AJAX
    const productGridContainer = document.getElementById('ProductGridContainer');

    if (productGridContainer) {
        // Usar MutationObserver para detectar quando o conteúdo é atualizado via AJAX
        const observer = new MutationObserver(function(mutations) {
            console.log('Detectada mudança no DOM, reinicializando dropdowns');
            setTimeout(initializeCustomDropdown, 100); // Pequeno atraso para garantir que o DOM esteja pronto
        });

        // Configurar o observer para observar alterações nos filhos do container
        observer.observe(productGridContainer, { childList: true, subtree: true });

        // Também observar alterações em FacetFiltersForm para casos onde o observer acima não detecte
        const facetForm = document.querySelector('facet-filters-form');
        if (facetForm) {
            observer.observe(facetForm, { childList: true, subtree: true });
        }
    }

    // Adicionar listeners para eventos específicos do Shopify também
    document.addEventListener('shopify:section:load', function() {
        console.log('Evento shopify:section:load detectado');
        setTimeout(initializeCustomDropdown, 100);
    });
});

// Reinicializar também em caso de atualização do histórico (usando os botões voltar/avançar)
window.addEventListener('popstate', function() {
    console.log('Evento popstate detectado');
    setTimeout(initializeCustomDropdown, 100);
});
